var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('tabela',{attrs:{"items":_vm.items,"loading":_vm.loading},on:{"rechargeTable":function($event){return _vm.getAll()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }